import { useProperty } from '@eti/providers';
import type {
  BrandedFareInfo,
  CabinBaggageTripSummary,
  CheckedBaggageSummary,
} from '@eti/schema-types';
import BrandedFareV1 from './BrandedFareV1';
import BrandedFareV2 from './BrandedFareV2';
import BrandedFareFeatures from './BrandedFareFeatures';

interface BrandedFareProps {
  brandedFareInformation: BrandedFareInfo;
  brandedFareName: string;
  cabinBaggageTripSummary: CabinBaggageTripSummary;
  checkedBaggageSummary: CheckedBaggageSummary;
  isPersonalItemIncluded: boolean;
  ticketingCarrierCodes: string[];
}

const BrandedFare = ({
  brandedFareInformation,
  brandedFareName,
  cabinBaggageTripSummary,
  checkedBaggageSummary,
  isPersonalItemIncluded,
  ticketingCarrierCodes,
}: BrandedFareProps) => {
  const { p } = useProperty();
  const brandedFareVersion = p('PaymentPage.BrandedFare.Version');
  const BrandedFareVersion = brandedFareVersion === 1 ? BrandedFareV1 : BrandedFareV2;
  return (
    <BrandedFareVersion brandedFareName={brandedFareName}>
      <BrandedFareFeatures
        brandedFareInformation={brandedFareInformation}
        cabinBaggageTripSummary={cabinBaggageTripSummary}
        checkedBaggageSummary={checkedBaggageSummary}
        isPersonalItemIncluded={isPersonalItemIncluded}
        ticketingCarrierCodes={ticketingCarrierCodes}
      />
    </BrandedFareVersion>
  );
};

export default BrandedFare;
